window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Toastr notifications
 */
window.toastr = require('toastr');
window.toastr.options.closeButton = true;
window.toastr.options.closeMethod = 'fadeOut';
window.toastr.options.positionClass = 'toast-top-left';
window.toastr.options.closeDuration = 300;
window.toastr.options.timeOut = 5000;
window.toastr.options.extendedTimeOut = 0;

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

require('select2');


window.moment = require('moment');
require('./libraries/redactor.min');
require('./libraries/fontcolor.min');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
document.addEventListener('DOMContentLoaded', function (event) {
    const hamburger = document.querySelector('[data-toggle="mobile-nav"]');
    const navbar = document.getElementById('navbar');
    const app = document.getElementById('app');
    const libraryHeader = document.getElementsByClassName('navbar--list-header')[0];
    const companyHeader = document.getElementsByClassName('navbar--list-header')[1];
    
    if (hamburger) {
        hamburger.addEventListener('click', () => {
            if (hamburger.classList.contains('active')) {
                hamburger.classList.remove('active');
                navbar.classList.remove('active');
                app.classList.remove('mobile--menu-open');
                libraryHeader.style.display = 'none';
                companyHeader.style.display = 'none';
            } else {
                hamburger.classList.add('active');
                navbar.classList.add('active');
                app.classList.add('mobile--menu-open');
                libraryHeader.style.display = 'block';
                companyHeader.style.display = 'block';
            }
        });
    }
});